exports.components = {
  "component---src-pages-get-notified-js": () => import("./../../../src/pages/getNotified.js" /* webpackChunkName: "component---src-pages-get-notified-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

